function init({ container, data }) {
  window.rm.utils.addEventListener(
    container.querySelector("form-actions"),
    "click",
    function (event, el) {
      let target = event.target;
      if (target.tagName != "BUTTON") {
        target = target.closest("button");
      }
      let dataset = target.dataset;

      if (dataset.action == "submit") {
        let activityFun = () => {};
        if (window.rm.hooks.hasOwnProperty('register_activity')) {
           activityFun = window.rm.hooks.register_activity(dataset);
        }

        if (window.rm.hooks.hasOwnProperty('before_submit_form')) {
          window.rm.hooks.before_submit_form(container, event);
        }

        window.rm.form.submit({
          container,
          data,
          form_name: dataset.form,
          button: target,
          activityFun,
        });
      } else if (dataset.action == "show") {
        window.rm.form.show({
          container,
          data,
          form_name: dataset.form,
        });
      } else if (dataset.action == "close") {
        window.rm.form.hide();
      }
    },
  );
}

export { init };
